import { connect } from 'react-redux'
import * as processSelector from '../../../process/state/instance-detail/selector'
import RefundSepaTransferWidget from './RefundSepaTransferWidget'


const mapStateToProps = (state, props) => {
    return {
        context: processSelector.selectProcessContext(state),
    }
}

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(RefundSepaTransferWidget)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/RefundSepaTransferWidgetContainer.js